import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { TaggedSOItemListV4 } from '~/components/supporting-object/tagged-so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const OUTCROP_SYNTHETIC_WELL_LOGS_ROUTE = graphql(`
  query OutcropSyntheticWellLogsRoute($id: ID!) {
    outcropGet(id: $id) {
      id
      syntheticWellLogs {
        ...syntheticWellLogParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
        georeferences {
          ...georeferenceParts
        }
      }

      studies {
        ...studyParts
        syntheticWellLogs {
          ...syntheticWellLogParts
          pictures {
            ...soPictureParts
          }
          files {
            ...fileParts
          }
          georeferences {
            ...georeferenceParts
          }
        }
      }
    }
  }
`);

export default function OutcropSyntheticWellLogsRoute() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(OUTCROP_SYNTHETIC_WELL_LOGS_ROUTE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    { query: OUTCROP_SYNTHETIC_WELL_LOGS_ROUTE, variables: { id: outcropId } },
  ]);

  const outcrop = data?.outcropGet;
  const syntheticWellLogs = outcrop?.syntheticWellLogs ?? [];
  const outcropStudies = R.sortBy(s => s.name, outcrop?.studies ?? []);

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <div className="space-y-4">
      <SOItemListV4
        items={syntheticWellLogs}
        soParentType="outcrop"
        soParentId={outcropId}
        // bookmarkParentType={BookmarkParentType.SyntheticWellLog}
        refetchQueries={refetchQueries}
      />

      <TaggedSOItemListV4
        outcropId={outcropId}
        studies={outcropStudies}
        supportObjectKey="syntheticWellLogs"
        refetchQueries={refetchQueries}
      />
    </div>
  );
}
